import React from "react"
import { ClassValue } from "clsx"
import { Check } from "lucide-react"

import { cn } from "@/lib/utils"
import { Badge } from "@/components/ui/components"

export const DiscountActiveLine = (props: {
  discountLabel: string | undefined
  activeText: string | undefined
  className?: ClassValue
  badgeClassName?: ClassValue
}) => (
  <div className={cn("flex flex-row items-center justify-start gap-1", props.className)}>
    <p className={"font-light"}>{props.discountLabel ?? ""}:</p>
    <DiscountBadge activeText={props.activeText} className={props.badgeClassName} />
  </div>
)

export const DiscountBadge = (props: { activeText?: string; className?: ClassValue }) => (
  <Badge className={cn("bg-primary text-white", props.className)}>
    <Check className={"size-4"} /> {props.activeText ?? "AKTIV"}
  </Badge>
)
